import { IsNumber, IsString } from 'class-validator';

export class DealRegionList {
    @IsNumber()
    id!: number;
    @IsNumber()
    customField!: number;
    @IsString()
    regionCode!: string;
    @IsString()
    regionText!: string;
}
